export const AUTH_URL = "https://authentication.traductorlsm.com/api";

export const MICROSERVICE01_URL = "http://process-text.traductorlsm.com";

export const SERVER_VIDEOS_URL = "https://videos.traductorlsm.com";
